// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_3d-1";
export var rateTableServiceLevelDropdown = "_3d-3";
export var rateTableTypeDropdown = "_3d-0";
export var rateTableValueModeDropdown = "_3d-2";